import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const WellbeingContext = React.createContext();

export const useWellbeingContext = () => useContext(WellbeingContext);

export function WellbeingProvider({ children }) {
  const [banner, setBanner] = useState({});
  const [subcategories, setSubcategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchData.get('https://run.mocky.io/v3/c037925c-0a67-45e6-9921-0b8489ade616').then(setBanner);
    fetchData
      .get('https://run.mocky.io/v3/775395f4-d3f8-480b-a535-72e3cb0b0291')
      .then(setSubcategories);
    fetchData.get('https://run.mocky.io/v3/aa16c95b-16ce-4f85-95d7-26b239a588c8').then(setArticles);
    fetchData.get('https://run.mocky.io/v3/ad83597b-e8d6-4652-a547-396feb51dfc9').then(setVideos);
  }, []);

  const value = useMemo(
    () => ({
      banner,
      subcategories,
      articles,
      videos,
    }),
    [banner, subcategories, articles, videos]
  );

  return <WellbeingContext.Provider value={value}>{children}</WellbeingContext.Provider>;
}
